import { redirect, createFileRoute } from "@tanstack/react-router";

import { pb } from "@/lib/pocketbase";
import SignupPage from "@/pages/signup";

export const Route = createFileRoute("/signup")({
  component: SignupPage,
  beforeLoad: () => {
    if (pb.authStore.isValid) {
      // Redirect to admin if already signed in
      throw redirect({ to: "/admin" });
    }
  },
});
